export const REVENUE_IE_URL = 'https://www.revenue.ie';
export const GOV_UK_URL = 'https://www.gov.uk/stamp-duty-land-tax/residential-property-rates';
